var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFundingNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2H2C0.9 2 0.01 2.9 0.01 4L0 22L4 18H18C19.1 18 20 17.1 20 16V4C20 2.9 19.1 2 18 2Z",
    fill: "#666666"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 4,
    width: 3,
    height: 7,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2388 11H20.2613C20.6693 11 21 10.6635 21 10.2485C21 10.1186 20.9669 9.99097 20.904 9.87798L15.8927 0.881138C15.6916 0.520037 15.2408 0.393187 14.8859 0.597811C14.7696 0.664872 14.6733 0.762795 14.6074 0.881138L9.59614 9.87798C9.39501 10.2391 9.5197 10.6977 9.87464 10.9023C9.9857 10.9663 10.1112 11 10.2388 11ZM15.6194 9.49698H14.8807C14.6767 9.49698 14.5114 9.32874 14.5114 9.12122V8.36971C14.5114 8.16218 14.6767 7.99395 14.8807 7.99395H15.6194C15.8234 7.99395 15.9888 8.16218 15.9888 8.36971V9.12122C15.9888 9.32874 15.8234 9.49698 15.6194 9.49698ZM15.6194 7.24244H14.8807C14.6767 7.24244 14.5114 7.07421 14.5114 6.86668V4.61215C14.5114 4.40462 14.6767 4.23639 14.8807 4.23639H15.6194C15.8234 4.23639 15.9888 4.40462 15.9888 4.61215V6.86668C15.9888 7.07421 15.8234 7.24244 15.6194 7.24244Z",
    fill: "#EF3B28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundingNotes);
export default __webpack_public_path__ + "static/media/fundingNotes.479427a1529a8afdabce05e6a6b4e57d.svg";
export { ForwardRef as ReactComponent };